import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './styles/components/chatbot.scss'
import './styles/components/header.scss'
import './styles/components/welcome.scss'
import './styles/components/stimuli.scss'
import './styles/components/headGlobal.scss'
import './styles/components/endSurvey.scss'
import Layout from './components/layout'

import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
    <Layout />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
